import Header from '../Header/Header'
import * as S from './Page.styles'
import { DivergenceDemandsState } from '../../DivergenceDemandsTypes'

interface PageProps {
  children: React.ReactNode;
  headerTitle: string;
  goBackRoute?: string;
  propertyToClear?: keyof DivergenceDemandsState | (keyof DivergenceDemandsState)[]
  hasBackButton?: boolean
}

const Page: React.FC<PageProps> = ({
  children, headerTitle, goBackRoute, propertyToClear, hasBackButton,
}) => (
  <S.PageContainer>
    <Header
      title={headerTitle}
      goBackRoute={goBackRoute}
      propertyToClear={propertyToClear}
      hasBackButton={hasBackButton}
    />
    {children}
  </S.PageContainer>
)

export default Page
